import { render, staticRenderFns } from "./ViewIndex.vue?vue&type=template&id=1af212e5&"
import script from "./ViewIndex.vue?vue&type=script&lang=js&"
export * from "./ViewIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports